import React from 'react'
import { Link } from 'react-router-dom'
import AddendumModalSF from '../../../components/superUser/loan/document/AddendumModalSF.js'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import SuperUserLoanPageUI from '../../../templates/SuperUserLoanPageUI.js'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import FileUploadModalSF from '../../../widgets/form/FileUploadModalSF'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import DocSigningNavUI from '../../../components/superUser/loan/DocSigningNavUI'
import DocumentSignSF from '../../../components/superUser/loan/document/DocumentSignSF'
import ButtonTinyUI from '../../../widgets/action/ButtonTinyUI'
import ClearAgreementSignListConfirmationModalSF from '../../../components/superUser/loan/ClearAgreementSignListConfirmationModalSF'

const DocumentSignPageUI = ({ context, errorList, loan, signedLoan, onRefreshClick,
  addendumUpdateMode, onAddendumUpdateClick, onAddendumUpdateCancelClick,
  addendumUploadMode, onAddendumUpload, onCancelAddendumUpload,
  onClearAgreementSignListClick, onClearAgreementSignListCancel, clearAgreementSignListMode,
}) =>
  <SuperUserLoanPageUI context={context} className='pg_su_loan_a_lst'
    backLink={`/su/${loan && loan.status === 'closed' ? 'closedLoans' : 'loans'}`}
    headerText={loan ? (loan.account.accountName + ' ' + (loan.loanName || '')) : 'Loan'}
    centered={!loan || !errorList} loan={loan} page='esigning'
  >
    {
      (!loan || !errorList) &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      loan &&
      <div>
        <LRTableActionsUI location='top'
          left={
            <span className='g_flex_left g_flex_h'>
              <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
              <span className='g_m_left_100 g_large'><b>Document Sign</b></span>
            </span>
          }
          right={
            <div className='g_flex_right'>
              <div className='g_flex_v'>
                {
                  loan.resolutionSign.boardMeetingDateF1 &&
                  <span className='g_flex_h'>
                    <span>Addendum: {loan.addendum === false ? 'Disabled' : 'Enabled'}</span>
                    <span className='icon icon-pencil g_link_2 g_m_left_50' onClick={onAddendumUpdateClick} />
                  </span>
                }
                {
                  loan.documentGenerateDateF &&
                  <span>Documents generated: {loan.documentGenerateDateF}</span>
                }
                {/*
                Addendum will be added from inside the CardUI below
              <Link className='g_m_left_50' to='#' onClick={onAddendumUploadClick}>Add addendum</Link>
              */}
              </div>
            </div>
          }
        />
        <DocSigningNavUI loan={loan} page='esigning' />

        {/*
        <TermSheetSignSF context={context} loan={loan} onRefreshClick={onRefreshClick} />
        */}
        {
          loan.agreementSignList && !loan.resolutionSign.boardMeetingDateF1 &&
          <div className='g_muted g_m_bottom_100'>
            An addendum doc can be added after other docs are generated for signing
          </div>
        }

        {
          signedLoan && signedLoan.loanId !== loan.loanId &&
          <Link to={`/su/loans/${signedLoan.loanId}/esigning`}>Go to signed loan</Link>
        }
        {/*
          <a> is needed if componentDidUpdate not used
          signedLoan && signedLoan.loanId !== loan.loanId &&
          <a href={`/su/loans/${signedLoan.loanId}/esigning`}>Go to signed loan</a>
        */}
        
        {
          loan.agreementSignList &&
          <DocumentSignSF context={context} loan={loan} onRefreshClick={onRefreshClick} />
        }

        {/*
          context.permissions.includes('su_superuser_business') &&
          <LoanDocSelectSF context={context} loan={loan} onRefreshClick={onRefreshClick} />
        */}
        <AddendumModalSF context={context} loan={loan} updateMode={addendumUpdateMode}
          onCancelClick={onAddendumUpdateCancelClick} onRefreshClick={onRefreshClick}
        />
        <FileUploadModalSF
          context={context}
          uploadMode={addendumUploadMode}
          onUpload={onAddendumUpload}
          onCancelClick={onCancelAddendumUpload}
          signedUrlApi={`/api/su/loans/${loan.loanId}/pdfDocuments/addendum/fileUploadSignedUrl`}
        />
        {
          context.permissions.includes('su_superuser_business') &&
          loan.agreementSignList && loan.agreementSignList.length > 0 &&
          <div className='g_m_top_100 g_text_right'>
            <ButtonTinyUI
              label='Reset agreement sign list'
              onClick={onClearAgreementSignListClick}
            />
          </div>
        }
        <ClearAgreementSignListConfirmationModalSF
          context={context}
          loan={loan}
          isOpen={clearAgreementSignListMode}
          onCancel={onClearAgreementSignListCancel}
          onRefreshClick={onRefreshClick}
        />
      </div>
    }
  </SuperUserLoanPageUI>

export default DocumentSignPageUI
